import { IconBrandFacebook, IconBrandInstagram, IconBrandTiktok, IconBrandX, IconWorld, type IconProps } from '@tabler/icons-react';
import type { OrgSocialPlatform } from '@re/shared';

export function OrgSocialPlatformIcon({ platform, ...props }: IconProps & { platform: OrgSocialPlatform }) {
  const p = { size: 18, stroke: 1.6, ...props };
  switch (platform) {
    case 'instagram':
      return <IconBrandInstagram {...p} />;
    case 'facebook':
      return <IconBrandFacebook {...p} />;
    case 'twitter':
      return <IconBrandX {...p} />;
    case 'tiktok':
      return <IconBrandTiktok {...p} />;
    default:
      return <IconWorld {...p} />;
  }
}
